module.exports = __webpack_public_path__ + "static/media/LAMF_thank_you_tick.e93cdb60.svg";